(function ( $ ){

	MP.paginate_category = function(){

		var window_offset = 0;

		var pageNumber = 1,
			btn = $("#more_posts"),
			load_to = $('#loaded_by_ajax'),
			loaded = $('#onload_posts'),
			has_more = true,
			speed = 500;
			
		function load_posts(post_type,posts_per_page,taxonomy,taxonomy_term,btn){
			
			var query_string = 	'action=more_post_ajax&postType=' + post_type + '&postsPerPage=' + posts_per_page + '&pageNumber=' +
								pageNumber + '&taxonomy=' + taxonomy + '&taxonomy_term=' + taxonomy_term ;
			
			pageNumber++;
			

			$.ajax({
				type: "POST",
				dataType: "html",
				url: imark.ajaxurl,
				data: query_string,
				success: function(data){ 

					var $data = $(data);

					requestAnimationFrame(lazy_load)

					if($data.length){

						load_to.append($data);

						if ( load_to.find('.box').length >= $data.data('total') - posts_per_page ) {
							btn.hide();
						}

					} else{
						btn.attr("disabled",true);
					}
					btn.removeClass('loading');

				},
				error : function(jqXHR, textStatus, errorThrown) {
				//	$loader.html(jqXHR + " :: " + textStatus + " :: " + errorThrown);
				}
			});
			return false;
		}


		btn.on("click",function(){ 
			var it = $(this);
		//	it.attr("disabled",true);
			var post_type = it.data('postType');
			var posts_per_page = it.data('postsPerPage');
			var taxonomy = it.data('taxonomy');
			var taxonomy_term = it.data('taxonomy-term');
			load_posts(post_type,posts_per_page,taxonomy,taxonomy_term,it);
			it.addClass('loading');
			
		});	

		if( $('.box-asset').length >= btn.data('term-count') ){	
			btn.attr("disabled",true);
		}


		window.addEventListener('load',function(){
			document.body.scrollTop = window.pageYOffset + 1;
			setTimeout(function(){
				document.body.scrollTop =  window.pageYOffset - 1; 
				
			});
		});

		var allowScrollClick = true;
		/*
		btn[0] && window.addEventListener('scroll', function(){
			if ( lib.isScrolledIntoView(btn[0])){
				allowScrollClick && btn.trigger('click');
				allowScrollClick = false;
			} else {
				allowScrollClick = true;
			}
		});
		*/

	};
	
  
})( window.jQuery );




// WEBPACK FOOTER //
// ./assets/js/c-paginate-category.js